"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDisplayOptions = void 0;
const immutable_1 = require("immutable");
exports.makeDisplayOptions = (0, immutable_1.Record)({
    expand: true,
    selected: false,
    path: null,
    children: null,
});
